import React from 'react';
import ForgotPasswordForm from '../../components/forms/ForgotPasswordForm/ForgotPasswordForm';
import { APP_CONFIG } from '../../config/constants';
import './ForgotPasswordPage.css';
import logo from '../../assets/logo.png';

const ForgotPasswordPage = () => {
    return (
        <div className="forgot-password-page">
            <div
                className="background-logo"
                style={{
                    backgroundImage: `url(${logo})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    opacity: 0.30,
                    position: 'absolute',
                    inset: 0,
                    zIndex: 0,
                }}
            />
            <div className="forgot-password-container">
                <div className="forgot-password-header">
                    <h1>{APP_CONFIG.APP_NAME}</h1>
                    <p className="subtitle">ein Produkt der {APP_CONFIG.COMPANY_NAME}</p>
                </div>

                <div className="forgot-password-box">
                    <ForgotPasswordForm />
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;